import { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function MinisterVerification() {
  const [searchName, setSearchName] = useState("");
  const [searchResult, setSearchResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ministers, setMinisters] = useState([]);
  const [showList, setShowList] = useState(false);

  useEffect(() => {
    fetchMinisters();
  }, []);

  const fetchMinisters = async () => {
    try {
      const response = await axios.get(`${API}/ordained-ministers`);
      if (response.data.success) {
        setMinisters(response.data.ministers);
      }
    } catch (err) {
      console.error("Error fetching ministers:", err);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchName.trim()) return;

    setLoading(true);
    setSearchResult(null);

    try {
      const response = await axios.get(`${API}/verify-minister?name=${encodeURIComponent(searchName)}`);
      setSearchResult(response.data);
    } catch (err) {
      setSearchResult({
        found: false,
        message: "Error searching. Please try again."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: "100vh", 
      background: "linear-gradient(180deg, #0a0a0a 0%, #111 100%)",
      padding: "20px"
    }}>
      {/* Header */}
      <div style={{ textAlign: "center", padding: "40px 20px", borderBottom: "2px solid #FFD700" }}>
        <h1 style={{ 
          color: "#FFD700", 
          fontSize: "2.5rem", 
          marginBottom: "10px",
          fontFamily: "'Playfair Display', serif"
        }}>
          Yisrael Learning Center
        </h1>
        <p style={{ color: "#CCCCCC", fontSize: "1.1rem" }}>
          Official Ordained Minister Verification
        </p>
      </div>

      <div style={{ maxWidth: "800px", margin: "40px auto" }}>
        {/* Search Section */}
        <div className="card" style={{ background: "#1a1a1a", padding: "30px" }}>
          <h2 style={{ color: "#FFD700", marginBottom: "20px", textAlign: "center" }}>
            Verify Ordained Minister
          </h2>
          <p style={{ color: "#CCCCCC", textAlign: "center", marginBottom: "30px" }}>
            Enter the minister's name to verify their ordination status with Yisrael Learning Center
          </p>

          <form onSubmit={handleSearch} style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <input
              type="text"
              placeholder="Enter minister's name..."
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              style={{
                flex: 1,
                minWidth: "200px",
                padding: "15px",
                fontSize: "1rem",
                background: "#222",
                border: "2px solid #333",
                borderRadius: "8px",
                color: "#EEEEEE"
              }}
              data-testid="minister-search-input"
            />
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: "15px 30px",
                background: "#FFD700",
                color: "#000",
                border: "none",
                borderRadius: "8px",
                fontWeight: "bold",
                cursor: "pointer",
                marginTop: 0
              }}
              data-testid="minister-search-btn"
            >
              {loading ? "Searching..." : "Verify"}
            </button>
          </form>

          {/* Search Result */}
          {searchResult && (
            <div style={{
              marginTop: "30px",
              padding: "25px",
              background: searchResult.found ? "#1a3a1a" : "#3a1a1a",
              borderRadius: "10px",
              border: `2px solid ${searchResult.found ? "#90EE90" : "#FF6B6B"}`
            }} data-testid="search-result">
              {searchResult.found ? (
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "3rem", marginBottom: "15px" }}>✓</div>
                  <h3 style={{ color: "#90EE90", marginBottom: "20px" }}>
                    Verified Ordained Minister
                  </h3>
                  <div style={{ 
                    display: "grid", 
                    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                    gap: "20px",
                    textAlign: "left"
                  }}>
                    <div style={{ background: "#0a0a0a", padding: "15px", borderRadius: "8px" }}>
                      <p style={{ color: "#999", fontSize: "0.85rem", marginBottom: "5px" }}>Name</p>
                      <p style={{ color: "#FFD700", fontSize: "1.2rem", fontWeight: "bold" }}>
                        {searchResult.name}
                      </p>
                    </div>
                    <div style={{ background: "#0a0a0a", padding: "15px", borderRadius: "8px" }}>
                      <p style={{ color: "#999", fontSize: "0.85rem", marginBottom: "5px" }}>Certificate Number</p>
                      <p style={{ color: "#FFD700", fontSize: "1.2rem", fontWeight: "bold" }}>
                        {searchResult.certificate_number}
                      </p>
                    </div>
                    <div style={{ background: "#0a0a0a", padding: "15px", borderRadius: "8px" }}>
                      <p style={{ color: "#999", fontSize: "0.85rem", marginBottom: "5px" }}>Ordination Date</p>
                      <p style={{ color: "#FFD700", fontSize: "1.2rem", fontWeight: "bold" }}>
                        {new Date(searchResult.ordination_date).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "3rem", marginBottom: "15px" }}>✗</div>
                  <h3 style={{ color: "#FF6B6B", marginBottom: "10px" }}>
                    Not Found
                  </h3>
                  <p style={{ color: "#CCCCCC" }}>{searchResult.message}</p>
                </div>
              )}
            </div>
          )}
        </div>

        {/* View All Ministers Toggle */}
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <button
            onClick={() => setShowList(!showList)}
            style={{
              background: "transparent",
              border: "2px solid #FFD700",
              color: "#FFD700",
              padding: "12px 30px",
              borderRadius: "25px",
              cursor: "pointer",
              marginTop: 0
            }}
          >
            {showList ? "Hide" : "View"} All Ordained Ministers ({ministers.length})
          </button>
        </div>

        {/* Ministers List */}
        {showList && ministers.length > 0 && (
          <div className="card" style={{ background: "#1a1a1a", padding: "30px", marginTop: "20px" }}>
            <h3 style={{ color: "#FFD700", marginBottom: "20px" }}>
              Ordained Ministers Registry
            </h3>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#222" }}>
                    <th style={{ padding: "12px", textAlign: "left", color: "#FFD700", borderBottom: "2px solid #333" }}>
                      Name
                    </th>
                    <th style={{ padding: "12px", textAlign: "left", color: "#FFD700", borderBottom: "2px solid #333" }}>
                      Certificate #
                    </th>
                    <th style={{ padding: "12px", textAlign: "left", color: "#FFD700", borderBottom: "2px solid #333" }}>
                      Ordination Date
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {ministers.map((minister, index) => (
                    <tr key={index} style={{ background: index % 2 === 0 ? "#1a1a1a" : "#222" }}>
                      <td style={{ padding: "12px", color: "#EEEEEE", borderBottom: "1px solid #333" }}>
                        {minister.name}
                      </td>
                      <td style={{ padding: "12px", color: "#87CEEB", borderBottom: "1px solid #333" }}>
                        {minister.certificate_number}
                      </td>
                      <td style={{ padding: "12px", color: "#CCCCCC", borderBottom: "1px solid #333" }}>
                        {new Date(minister.ordination_date).toLocaleDateString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {showList && ministers.length === 0 && (
          <div className="card" style={{ background: "#1a1a1a", padding: "30px", marginTop: "20px", textAlign: "center" }}>
            <p style={{ color: "#999" }}>No ordained ministers in the public registry yet.</p>
          </div>
        )}

        {/* Footer */}
        <div style={{ textAlign: "center", marginTop: "40px", padding: "20px" }}>
          <p style={{ color: "#666", fontSize: "0.9rem" }}>
            Twelve Tribes of Yisrael | Est. 2012 | Chief/Priest: Ykbn Yoonw
          </p>
          <a 
            href="/"
            style={{ 
              color: "#FFD700", 
              textDecoration: "none",
              display: "inline-block",
              marginTop: "15px"
            }}
          >
            ← Return to Yisrael Learning Center
          </a>
        </div>
      </div>
    </div>
  );
}

export default MinisterVerification;
